<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "timer" [fullScreen] = "false"><p style="color: white" > 
    Loading... </p></ngx-spinner>
<div class="content-wrapper" style="min-height: 307px">
    <div class="col-md-12">
        <!-- แบบขอ -->
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header" style="color: red;"> <h4>ขอบาร์ดโค้ดแปลงอ้อย เฉพาะคิวล็อค คิวโยน และ คิวรถตัด</h4>  </div>
                    <div class="card-body">
                        <div class="input-group mb-3" [formGroup]="Searchfmcode">
                            <input type="text" class="form-control" placeholder="โควตาชาวไร่ 10 หลัก" formControlName="fmcode">
                            <button class="btn btn-info btn-sm" (click)="LoadFarmerData();"><i class="fas fa-search"></i></button>
                        </div>

                        <table class="table table-sm">
                            <thead>
                                <th scope="col">หมายเลขแปลง</th>
                                <th scope="col">โควตา</th>
                                <th scope="col">ชื่อ - สกุล</th>
                                <th scope="col">ประเภทอ้อย</th>
                                <th scope="col">พื้นที่</th>
                                <th scope="col">กลุ่ม</th>
                                <th scope="col">อ้อยเข้า</th>
                                <th scope="col">อ้อยคงเหลือ</th>
                                <th scope="col">ที่ได้รับ</th>
                                <th scope="col">ใช้แล้ว</th>
                                <th scope="col">คงเหลือ</th>
                                <th scope="col">Action</th>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of fmdata">
                                    <td>{{item.intlandno}}</td>
                                    <td>{{item.fmcode}}</td>
                                    <td>{{item.fmname}}</td>
                                    <td>{{item.CaneTypeName}}</td>
                                    <td>{{item.landvalue}}</td>
                                    <td>{{item.groupCode}}</td>
                                    <td>{{item.canein}}</td>
                                    <td>{{item.caneleft}}</td>
                                    <td>{{item.cntq_get}}</td>
                                    <td>{{item.cntq_used}}</td>
                                    <td>{{item.cntq_left}}</td>                                    
                                    <td>
                                        <button class="btn btn-warning btn-sm" 
                                        data-bs-toggle="modal" (click)="Showdata(item.itid);" data-bs-target="#AskBarcode">บันทึกคำขอ</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <!-- แบบขอ -->


        <!-- รายการที่ขอ -->
        <div class="row">
            <div class="card">
                <div class="card-header">รายการคำขอภายในโซน</div>
                <div class="card-body">
                    <table class="table table-sm">
                        <thead>
                            <th scope="col">วันที่เพิ่ม</th>
                            <th scope="col">ผู้ขอ</th>
                            <th scope="col">จำนวน</th>
                            <th scope="col">เลขแปลง</th>
                            <th scope="col">โซน</th>
                            <th scope="col">ชื่อชาวไร่</th>
                            <th scope="col">กลุ่ม</th>
                            <th scope="col">พื้นที่</th>
                            <th scope="col">ประเมิน</th>
                            <th scope="col">อ้อยเข้า</th>
                            <th scope="col">สถานะ</th>
                            <th scope="col">หมายเหตุ</th>
                            <th scope="col">ยกเลิก</th>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of askbyzone">
                                <td>{{formatDate(item.dateadd)}}</td>
                                <td>{{item.supcode}}</td>
                                <td>{{item.num_qcard}}</td>
                                <td>{{item.landno}}</td>
                                <td>{{item.supzone}}</td>
                                <td>{{item.fmname}}</td>
                                <td>{{item.groupCode}}</td>
                                <td>{{item.landvalue}}</td>
                                <td>{{item.Assess}}</td>
                                <td>{{item.canein}}</td>
                                <td>{{item.status_desc}}</td>
                                <td>{{item.comment}}</td>
                                <td  *ngIf="item.status != 1">
                                    <button class="btn btn-danger btn-sm" (click)="CancleAskBarcode(item.id)">ยกเลิก</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- รายการที่ขอ -->
    </div>

  
  <!-- Modal -->
  <div class="modal fade" id="AskBarcode" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">ฟอร์มขอ BarCode</h5>
          <button  class="btn btn-sm btn-close"  (click)="ChoseModal();">X</button>
        </div>
        <div class="modal-body" *ngFor="let item of onedata">
            <p>ชื่อชาวไร่ :{{item.fmname}}</p>
            <p>แปลง :{{item.intlandno}}</p>
            <p>ประเภทอ้อย :{{item.CaneTypeName}}</p>
            <p>พื้นที่ :{{item.landvalue}}</p>
            <p>กลุ่ม :{{item.groupCode}}</p>
          <form [formGroup]="AskBarcode">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">จำนวน</span>
                </div>
                <input type="number" class="form-control" formControlName="countcode" placeholder="เช่น 1,2">
              </div>

              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">ประเภทคิว</span>
                </div>
                <select class="form-control" formControlName="qwant" [ngClass]="{ 'is-invalid':  form.qwant.errors }">
                  <option value="0" selected disabled>เลือกประเภทคิวที่จะขอ</option>
                  <option value="1">คิวล็อค</option>
                  <option value="2">คิวโยน</option>
                  <option value="3">คิวตัด</option>
                </select>
              </div>
              <p *ngIf="form.qwant.value == 0" style="color: red;">เลือกประเภทคิว</p>

              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">หมายเหตุ</span>
                </div>
                <input type="text" class="form-control" formControlName="fmcomment" placeholder="หมายเหตุจะใส่หรือไม่ก็ได้">
              </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="ChoseModal();">Close</button>
          <button type="button" class="btn btn-primary" (click)="InsertAskBarcode();">บันทึกคำขอ</button>
        </div>
      </div>
    </div>
  </div>

</div>


<app-footer></app-footer>